module.exports = __webpack_public_path__ + "img/public_1.3f9785f8.jpg";